import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  themeSubject: Subject<string>;

  // Inject the HttpClient service
  constructor(private http: HttpClient) {
    this.themeSubject =new Subject();
  }
  
  get(url: string): Observable<any> {
    return this.http.get<any>(url);
  }
  
  post(url: string, options: any): Observable<any> {
    return this.http.post(url, options);
  }

  put(url: any, options: any) {
    return this.http.put(url, options);
  }
  
  delete(url: any, options: any) {
    return this.http.delete(url, options);
  }

  setThemeData(obj:string) {
    this.themeSubject.next(obj);
  }

  getThemeData(): Observable<string> {
    return this.themeSubject.asObservable();
  }
}
